import { faUserSecret } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar } from '@tryhackme/thm-ui-components';
import { useIsDarkMode } from 'src/common/hooks/use-is-dark-mode';
import Echo from 'src/images/pngs/landing/tutor/echo.png';
import { StyledNightOwlPill, StyledPillContainer, StyledPostRoomCompletionFeedbackHeader, StyledPostRoomCompletionFeedbackIcon, StyledPostRoomCompletionFeedbackSubtitle, StyledPostRoomCompletionFeedbackTitle } from '../post-room-completion-feedback-step.styles';
interface FeedbackHeaderProps {
  isLoading?: boolean;
  title?: string;
  subtitle?: string;
  showNightOwlPill?: boolean;
}
export const FeedbackHeader = ({
  isLoading = false,
  title,
  subtitle,
  showNightOwlPill = false
}: FeedbackHeaderProps) => {
  const isDarkMode = useIsDarkMode();
  const defaultTitle = isLoading ? 'Let Echo analyze your performance...' : 'We launched you and you blasted through!';
  const defaultSubtitle = isLoading ? "We're generating personalized feedback based on your commands and approach." : "It turns out you're built for this.";
  return <StyledPostRoomCompletionFeedbackHeader data-sentry-element="StyledPostRoomCompletionFeedbackHeader" data-sentry-component="FeedbackHeader" data-sentry-source-file="feedback-header.tsx">
      <StyledPostRoomCompletionFeedbackIcon data-sentry-element="StyledPostRoomCompletionFeedbackIcon" data-sentry-source-file="feedback-header.tsx">
        <Avatar avatarSrc={Echo} hasBorder={false} size="6.4rem" hasHover={false} data-sentry-element="Avatar" data-sentry-source-file="feedback-header.tsx" />
      </StyledPostRoomCompletionFeedbackIcon>

      {isLoading ? <div>
          <StyledPostRoomCompletionFeedbackTitle>{title || defaultTitle}</StyledPostRoomCompletionFeedbackTitle>
          <StyledPostRoomCompletionFeedbackSubtitle>
            {subtitle || defaultSubtitle}
          </StyledPostRoomCompletionFeedbackSubtitle>
        </div> : <>
          <StyledPostRoomCompletionFeedbackTitle>{title || defaultTitle}</StyledPostRoomCompletionFeedbackTitle>

          <StyledPillContainer>
            <StyledPostRoomCompletionFeedbackSubtitle>
              {subtitle || defaultSubtitle}
            </StyledPostRoomCompletionFeedbackSubtitle>
          </StyledPillContainer>

          {showNightOwlPill && <StyledNightOwlPill $isDarkMode={isDarkMode}>
              <FontAwesomeIcon icon={faUserSecret} />
              Explorer
            </StyledNightOwlPill>}
        </>}
    </StyledPostRoomCompletionFeedbackHeader>;
};